/*eslint-disable*/
import React, { useState } from 'react'
import { Button, Icon } from 'semantic-ui-react'


import DeleteModal from '../../modals/deleteModal'

function ProductActionButton(props) {
    const [tyreId, setTyreId] = useState('')
    const [openBox, setopenBox] = useState(false)
    const [success, setsuccess] = useState(false)

    let handleDelete = () => {
        //add delete 
    }

    let handleEdit = (e) => {
        let mainData = props.data
        console.log("Product Dtata", props)
        let history = props.agGridReact.props.baseUrl.history
        history.push({ pathname: '/edit-product', state: { id: mainData.id } })
    }


    // let handleOpenHistory = (e) => {
    //     let mainData = props.data
    //     let history = props.agGridReact.props.baseUrl.history
    //     history.push({ pathname: '/jobcard-info', state: { id: mainData.id } })
    // }

    let handleOpenDelete = (e) => {
        let mainData = props.data
        setTyreId(mainData.id)
        setopenBox(true)
    }

    let handleCloseDelete = () => {
        setopenBox(false)
    }

    let mainData = props.data

    // const updateTyre = props.agGridReact ? props.agGridProps.baseUrl.updateTyre : ''

    return (
        <>
            {console.log("MainDatttatatata", mainData)}
            {/* <Button disabled={ true} onClick={handleOpenHistory} basic size="mini" type="button" icon> <Icon name="history" color="blue" /></Button> */}
            <Button onClick={handleEdit} basic size="mini" type="button" icon> <Icon name="edit" color="green" /></Button>
            <Button onClick={handleOpenDelete} basic size="mini" type="button" icon> <Icon name="trash" color="red" /></Button>
            <DeleteModal isloading={success} open={openBox} onClose={handleCloseDelete} handleDelete={handleDelete} /> 
        </>
    )
}

export default ProductActionButton
